import { api } from "@/api/api";

export const Qna = {
    state: {
        qnaList: [],
        totalCount: 0,
    },
    getters: {
        getQnaList(state) {
            return state.qnaList;
        },
        getQnaTotalCount(state) {
            return state.totalCount;
        }
    },
    mutations: {
        setQnaList(state, payload) {
            state.qnaList = payload;
        },
        setQnaTotalCount(state, payload) {
            state.totalCount = payload;
        }
    },
    actions: {
        async getQnaList({ commit }, param) {
            await api.qna
                .getQnaList(param)
                .then((res) => {
                    console.log(res);
                    commit("setQnaList", res.data.qna);
                    commit("setQnaTotalCount", res.data.total)
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getQna(_, id) {
            const response = await api.qna.getQna(id).catch((err) => {
                console.log(err);
                return Promise.reject(err.response.data.message);
            });
            return Promise.resolve(response.data);
        },

        async addQna({ dispatch }, args) {
            await api.qna
                .addQna(args)
                .then(() => {
                    dispatch("getQnaList");
                })
                .catch((err) => {
                    console.log(err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve();
        },

        async updateQna({ dispatch }, args) {
            await api.qna
                .updateQna(args)
                .then(() => {
                    dispatch("getQnaList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deleteQna({ dispatch }, args) {
            await api.qna
                .deleteQna(args)
                .then(() => {
                    dispatch("getQnaList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async updateAnswer(_, args) {
            await api.qna.updateAnswer(args.id, args.param).catch((err) => {
                console.timeLog(err)
            })
            return Promise.resolve();

        }
    },
};
